import { useState } from "react";

export const AsyncStatus = ({ children }) => {
  const [isFetching, setFetching] = useState(false);
  const [error, setError] = useState(null);
  return children({ error, isFetching, setFetching, setError });
};
